/**
 * * Режимы работы инпута
 */
export enum TaskInputNameModeEnum {
  /**Режим при создании задачи */
  Create = "create",
  /**Режим отображения задачи */
  View = "view",
  /**Режим редактирования задачи */
  Edit = "edit",
}
